import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../util/api";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarTipoTaxaImposto, setModalDeletarTipoTaxaImposto } from "../redux/slices/tipoTaxaImposto/tipoTaxaImpostoSlice";

export const cadastrarTipoTaxaImposto = createAsyncThunk("/TipoTaxaImposto/CadastrarTipoTaxaImposto", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/TipoTaxaImposto/CadastrarTipoTaxaImposto", payload.value);
    toastSucess("Tipo taxa imposto cadastrado com sucesso");
    dispatch(setModalCadastrarTipoTaxaImposto(false));
    dispatch(setLoading(false));

    dispatch(buscarTipoTaxaImposto(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarTipoTaxaImposto = createAsyncThunk("/TipoTaxaImposto/BuscarTipoTaxaImposto", async (pesquisar: string | null) => {
  try {
    const data = await api.get("/TipoTaxaImposto/BuscarTipoTaxaImposto", {
      params: { pesquisar: pesquisar },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarTipoTaxaImposto = createAsyncThunk("/TipoTaxaImposto/AtualizarTipoTaxaImposto", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/TipoTaxaImposto/AtualizarTipoTaxaImposto", payload.value);
    toastSucess("Tipo taxa imposto atualizado com sucesso");
    dispatch(setModalCadastrarTipoTaxaImposto(false));
    dispatch(setLoading(false));

    dispatch(buscarTipoTaxaImposto(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarTipoTaxaImposto = createAsyncThunk("/TipoTaxaImposto/DeletarTipoTaxaImposto", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/TipoTaxaImposto/DeletarTipoTaxaImposto/?id=" + payload.value);
    toastSucess("Tipo taxa imposto removido com sucesso");
    dispatch(setModalDeletarTipoTaxaImposto(false));
    dispatch(setLoading(false));

    dispatch(buscarTipoTaxaImposto(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
